import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

// Material
import Chip from '@mui/material/Chip';

// Components
import Autocomplete from '../Autocomplete';

// Hooks
import useUser from '../../../hooks/user/useUser';
import useBranches from '../../../hooks/branch/useBranches';

const RenderTags = (value, getTagProps) =>
    value.map((option, index) => {
        return <Chip key={index} label={`${option?.name}`} {...getTagProps({ index })} />
    })

const AutocompleteBranches = ({ multiple, business, value, getOptionValue, ...rest }) => {
    const { branch: userBranch } = useUser();
    const { branches, loading } = useBranches();

    const options = useMemo(() => branches
        .filter(b => !userBranch || b.country === userBranch.country)
        .filter(b => {
            if (!business || business.length === 0)
                return true;

            return Array.isArray(business)
                ? business.some(t1 => t1 === b.businessId)
                : b.businessId === business;
        })
        , [branches, business, userBranch]);

    const selected = useMemo(() => {
        if (!value || !branches || branches.length === 0)
            return multiple ? [] : '';

        if (multiple)
            return Array.isArray(value)
                ? branches.filter(b => value && value.some(v => getOptionValue(b) === v))
                : [branches.find(b => getOptionValue(b) === value)];

        return branches.find(b => getOptionValue(b) === value)
    }, [multiple, branches, value, getOptionValue])

    return (
        <Autocomplete
            size='small'
            name='branches'
            label='Sucursales'
            placeholder='Ej.: Local Medrano'
            getOptionValue={getOptionValue}
            {...rest}
            multiple={multiple}
            value={selected}
            options={options}
            disabled={loading || branches.length === 0}
            data-testid='branches-autocomplete'
            renderTags={multiple && RenderTags}
        />
    )
}

AutocompleteBranches.defaultProps = {
    getOptionValue: (option) => option?.id || option,
    getOptionLabel: (option) => option?.name || option
}

AutocompleteBranches.prototype = {
    getOptionValue: PropTypes.func,
    getOptionLabel: PropTypes.func
}

export default AutocompleteBranches;